(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-switch"] && !Shopify.designMode) return;
  try {
    
  class ContentSwitch extends HTMLElement {
    get autoRotate() {
      return this.hasAttribute('auto-rotate');
    }

    get imageDuration() {
      const duration = Number.parseInt(
        this.getAttribute('image-duration'),
        10
      );

      return Number.isFinite(duration) && duration > 0
        ? duration
        : 5000;
    }

    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.slideshow = this.querySelector(':scope > slideshow-component');
      this.mobileLayout = window.matchMedia('(max-width: 749px)');
      this.heightFrame = undefined;
      this.isVisible = false;
      this.rotationTimer = undefined;
this.activeSlide = this.querySelector(
  "slideshow-slide[aria-hidden='false']"
);

this.reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      this.handleSelection = (event) => {
      if (event.target !== this.slideshow) return;
      this.activeSlide =
      event.detail?.slide ||
      this.slideshow?.querySelectorAll(':scope > slideshow-container > slideshow-slides > slideshow-slide')[event.detail?.index] ||
      this.querySelector(
      "slideshow-slide[aria-hidden='false']"
    );

  this.syncActiveSlide();
};
      this.handleMotionChange = () => this.syncActiveSlide();
      this.handleLayoutChange = () => this.requestMobileHeight();

      window.addEventListener('resize', this.handleLayoutChange, {
        signal: this.controller.signal,
      });
      this.mobileLayout.addEventListener('change', this.handleLayoutChange, {
        signal: this.controller.signal,
      });
      this.addEventListener('load', this.handleLayoutChange, {
        capture: true,
        signal: this.controller.signal,
      });
      this.panelObserver = new ResizeObserver(this.handleLayoutChange);
      this.slideshow?.querySelectorAll(
        ':scope > slideshow-container > slideshow-slides > slideshow-slide > .content-switch__panel'
      ).forEach((panel) => this.panelObserver.observe(panel));

      this.handleVideoEnded = (event) => {
        if (
          !this.autoRotate ||
          !this.isVisible ||
          this.reduceMotion.matches
        ) {
          return;
        }

        const video = event.currentTarget;
        const slide = video.closest('slideshow-slide');
        const isActive = slide === this.activeSlide;

        if (isActive) {
          this.advance();
        }
      };

      this.addEventListener(
        'slideshow:select',
        this.handleSelection,
        { signal: this.controller.signal }
      );

      this.reduceMotion.addEventListener(
        'change',
        this.handleMotionChange,
        { signal: this.controller.signal }
      );

      this.querySelectorAll(
        'video.content-switch__video'
      ).forEach((video) => {
        video.addEventListener(
          'ended',
          this.handleVideoEnded,
          { signal: this.controller.signal }
        );
      });

      this.syncActiveSlide();

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.isVisible = entry.isIntersecting;
          this.syncActiveSlide();
        },
        { threshold: 0.15 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.panelObserver?.disconnect();
      window.cancelAnimationFrame(this.heightFrame);
      this.style.removeProperty('--content-switch-active-height');

      window.clearTimeout(this.rotationTimer);

      this.querySelectorAll('video').forEach((video) => {
        video.pause();
      });

      this.controller = undefined;
      this.observer = undefined;
      this.rotationTimer = undefined;
      this.heightFrame = undefined;
    }

    requestMobileHeight() {
      if (this.heightFrame !== undefined) return;
      this.heightFrame = window.requestAnimationFrame(() => {
        this.heightFrame = undefined;
        if (!this.isConnected) return;
        if (!this.mobileLayout.matches) {
          this.style.removeProperty('--content-switch-active-height');
          return;
        }
        const panel = this.activeSlide?.querySelector(':scope > .content-switch__panel');
        if (!panel) return;
        const height = Math.ceil(panel.getBoundingClientRect().height);
        if (height <= 0) return;
        const value = `${height}px`;
        if (this.style.getPropertyValue('--content-switch-active-height') !== value) {
          this.style.setProperty('--content-switch-active-height', value);
        }
      });
    }

    syncActiveSlide() {
      this.requestMobileHeight();
      window.clearTimeout(this.rotationTimer);
      this.rotationTimer = undefined;

      const shouldPlay =
        this.isVisible && !this.reduceMotion.matches;

      const activeSlide =
  this.activeSlide ||
  this.querySelector(
    "slideshow-slide[aria-hidden='false']"
  );

this.activeSlide = activeSlide;

const activeVideo = activeSlide?.querySelector(
  'video.content-switch__video'
);

      this.querySelectorAll(
        'video.content-switch__video'
      ).forEach((video) => {
        const slide = video.closest('slideshow-slide');
        const isActive = slide === activeSlide;

        /*
         * 开启自动轮播：视频播完后切换，不循环。
         * 关闭自动轮播：维持原来的循环播放。
         */
        video.loop = !this.autoRotate;

        if (shouldPlay && isActive) {
          if (video.ended) {
            video.currentTime = 0;
          }

          video.play().catch(() => {});
        } else {
          video.pause();

          if (
            this.autoRotate &&
            !isActive &&
            video.currentTime !== 0
          ) {
            video.currentTime = 0;
          }
        }
      });

      /*
       * 视频 Item 由 ended 事件控制切换；
       * 图片 Item 按设置的秒数自动切换。
       */
      if (
        !this.autoRotate ||
        !shouldPlay ||
        activeVideo
      ) {
        return;
      }

      this.rotationTimer = window.setTimeout(
        () => this.advance(),
        this.imageDuration
      );
    }

    advance() {
      window.clearTimeout(this.rotationTimer);
      this.rotationTimer = undefined;

      const slideshow = this.querySelector(
        'slideshow-component'
      );

      if (typeof slideshow?.next === 'function') {
        slideshow.next();
      } else {
        this.querySelector(
          '.content-switch__controls .slideshow-control--next'
        )?.click();
      }
    }
  }

  if (!customElements.get('content-switch')) {
    customElements.define(
      'content-switch',
      ContentSwitch
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  const torinFilteredProductLinkSelector = [
    'a.product-card__link',
    'a[ref="cardGalleryLink"]',
    'a[ref="productTitleLink"]',
    'a.product-card-link[href*="/products/"]',
  ].join(',');

  const torinSyncFilteredProductLinks = (root = document) => {
    const scope =
      root && typeof root.querySelectorAll === 'function'
        ? root
        : document;

    scope
      .querySelectorAll('[data-product-card-filter-url]')
      .forEach((item) => {
        const destination = item.dataset.productCardFilterUrl;

        if (!destination) return;

        item
          .querySelectorAll(torinFilteredProductLinkSelector)
          .forEach((link) => {
            link.setAttribute('href', destination);
          });

        item
          .querySelectorAll('product-card[data-product-transition]')
          .forEach((card) => {
            card.removeAttribute('data-product-transition');
          });
      });
  };

  const torinSyncClickedFilteredProductLink = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const link = target.closest(torinFilteredProductLinkSelector);

    if (!(link instanceof HTMLAnchorElement)) return;

    const item = link.closest('[data-product-card-filter-url]');
    const destination = item?.dataset.productCardFilterUrl;

    if (!destination) return;

    link.setAttribute('href', destination);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => torinSyncFilteredProductLinks(),
      { once: true }
    );
  } else {
    torinSyncFilteredProductLinks();
  }

  document.addEventListener('shopify:section:load', (event) => {
    torinSyncFilteredProductLinks(event.target);
  });

  document.addEventListener(
    'pointerdown',
    torinSyncClickedFilteredProductLink,
    true
  );

  document.addEventListener(
    'click',
    torinSyncClickedFilteredProductLink,
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter') {
        torinSyncClickedFilteredProductLink(event);
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class TabbedImageWithText extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = Array.from(this.querySelectorAll('[data-tabbed-image-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-tabbed-image-panel]'));

      this.panels.forEach((panel, index) => {
        const label = panel.dataset.tabLabel?.trim();
        if (label && this.tabs[index]) this.tabs[index].textContent = label;
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab), { signal });
        tab.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      });

      document.addEventListener('shopify:block:select', (event) => this.handleEditorSelect(event), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = undefined;
    }

    activate(tab, moveFocus = false) {
      const index = this.tabs.indexOf(tab);
      if (index < 0 || !this.panels[index]) return;

      this.tabs.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.setAttribute('aria-selected', String(isActive));
        item.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        panel.toggleAttribute('inert', !isActive);
      });

      if (moveFocus) {
        tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      if (currentIndex < 0) return;

      const lastIndex = this.tabs.length - 1;
      const isRtl = getComputedStyle(this).direction === 'rtl';
      let nextIndex = currentIndex;

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = lastIndex;
      if (event.key === 'ArrowRight') nextIndex = isRtl ? currentIndex - 1 : currentIndex + 1;
      if (event.key === 'ArrowLeft') nextIndex = isRtl ? currentIndex + 1 : currentIndex - 1;

      if (!['Home', 'End', 'ArrowRight', 'ArrowLeft'].includes(event.key)) return;

      event.preventDefault();
      if (nextIndex < 0) nextIndex = lastIndex;
      if (nextIndex > lastIndex) nextIndex = 0;
      this.activate(this.tabs[nextIndex], true);
    }

    handleEditorSelect(event) {
      if (!(event.target instanceof HTMLElement)) return;

      const panel = event.target.closest('[data-tabbed-image-panel]');
      if (!panel || !this.contains(panel)) return;

      const index = this.panels.indexOf(panel);
      if (index >= 0) this.activate(this.tabs[index]);
    }
  }

  if (!customElements.get('tabbed-image-with-text')) {
    customElements.define('tabbed-image-with-text', TabbedImageWithText);
  }

  } catch(e) { console.error(e); }
})();
})();
